module.exports = __webpack_public_path__ + "static/media/notes.b31e5863.png";